import { render, staticRenderFns } from "./EditPersonTabPerso.vue?vue&type=template&id=c3cdfede&scoped=true&"
import script from "./EditPersonTabPerso.vue?vue&type=script&lang=js&"
export * from "./EditPersonTabPerso.vue?vue&type=script&lang=js&"
import style0 from "./EditPersonTabPerso.vue?vue&type=style&index=0&id=c3cdfede&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3cdfede",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VForm,VRow})
